// In your slices/Content/UpdateCategorySlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  response: null,
  error: null
};

const updateFoodCategoriesSlice = createSlice({
  name: 'updateFoodCategories',
  initialState,
  reducers: {
    updateFoodCategoriesRequest: (state) => {
      state.loading = true;
      state.response = null;
      state.error = null;
    },
    updateFoodCategoriesSuccess: (state, action) => {
      state.loading = false;
      state.response = action.payload;
      state.error = null;
    },
    updateFoodCategoriesFailure: (state, action) => {
      state.loading = false;
      state.response = null;
      state.error = action.payload;
    },
    updateFoodCategoriesStateReset: (state) => {
      state.loading = false;
      state.response = null;
      state.error = null;
    }
  }
});

export const {
  updateFoodCategoriesRequest,
  updateFoodCategoriesSuccess,
  updateFoodCategoriesFailure,
  updateFoodCategoriesStateReset
} = updateFoodCategoriesSlice.actions;

export default updateFoodCategoriesSlice.reducer;

